import styled from "styled-components";

import { setFontVariant, colorsPalettes, mixins } from "@similarweb/styles";
import { Switcher } from "@similarweb/ui-components";

import { KeywordsCampaignGenericStepWrapper } from "app/components/campaigns/campaigns-wizard/CampaignsStyledComponents";
import { FlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const KeywordsCampaignSwitcherStyled = styled(Switcher)`
    display: flex;
    overflow: hidden;

    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 3px;

    span {
        & > span {
            border-right: 1px solid ${colorsPalettes.carbon[50]};
            width: auto;
            height: auto;
            padding: 11px 10px;
            color: ${colorsPalettes.midnight[200]};

            &.selected {
                color: ${colorsPalettes.blue[400]};
            }
        }

        &:nth-last-child(1) > span {
            border-right: none;
        }
    }
`;

export const KeywordsCampaignSearchEnginesStepWrapper = styled(KeywordsCampaignGenericStepWrapper)`
    width: 700px;
    padding: 32px 32px 0;
    min-height: 632px;
`;

export const SearchEngineItemEditModeWrapper = styled(FlexColumn)`
    padding: 16px;
    gap: 12px;
    background-color: ${colorsPalettes.carbon[25]};
    border-radius: 6px;
`;

export const SearchEngineItemEditModeComponentWrapper = styled(FlexRow)`
    gap: 12px;
`;

export const SearchEngineItemRow = styled(FlexRow)`
    align-items: center;
    gap: 12px;
`;

export const SearchEngineDeviceRadioButtonsWrap = styled(FlexRow)``;

export const SearchEngineItemSummary = styled(FlexRow)`
    height: 50px;
`;

export const SearchEngineItemIcon = styled(FlexRow)`
    min-width: 40px;
`;

export const SearchEngineItemLocation = styled.span`
    color: ${colorsPalettes.carbon[400]};
    ${setFontVariant("input2")};
`;

export const SearchEngineItemButtons = styled(FlexRow)`
    padding: 12px 0 12px 0;
    margin-right: 5px;
    margin-left: auto;

    .SWReactIcons {
        svg {
            path {
                fill: ${colorsPalettes.carbon[100]};
                fill-opacity: 1;
            }
        }
    }

    button .SWReactIcons svg {
        path {
            fill: ${colorsPalettes.carbon[400]};
        }
    }
`;

export const SearchEngineCompanyDropdownContainer = styled.div`
    flex: 1;
    .DropdownButton {
        div {
            &:hover {
                background-color: transparent;
            }
            text-indent: 0;
        }
    }
`;

export const SearchEngineLanguageDropdownContainer = styled.div`
    width: 191px;
    .DropdownItem {
        height: 35px;
        line-height: 35px;
        ${mixins.truncateText()};
    }
    .DropdownItem:hover {
        background-color: transparent;
    }
`;

export const LanguageDropdownItemWrapper = styled.div``;

export const SearchEngineLocationDropdownContainer = styled.div`
    flex: 1;

    .DropdownItem:hover {
        background-color: transparent;
    }
`;

export const RemoveSearchEngineModalMessage = styled(FlexColumn)`
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
    width: 352px;
    height: 80px;
    justify-content: center;
`;

export const DuplicateSearchEngineModalMessage = styled(FlexColumn)`
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
    height: 100px;
    justify-content: center;
`;

export const RemoveSearchEngineModalTitle = styled.div``;

export const SearchEngineCompanyDropdownPlaceholder = styled(FlexRow)`
    height: 25px;
    display: flex;
    line-height: 25px;
    .SWReactIcons {
        margin-right: 10px;
    }
`;

export const EditSearchEngineListWrapper = styled.div`
    > div:not(:last-child) {
        position: relative;

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            border-bottom: 1px solid ${colorsPalettes.carbon[50]};
        }
    }
`;
export const EditSearchEngineWrapper = styled.div`
    max-width: 500px;
    margin-bottom: 48px;
`;
